import React from 'react';
import CenterContentBox from "../../Champions/ContentWrapper";
import AramSearch from "./AramSearch";
import AramRank from "./AramRank";
import {useSelector} from "react-redux";


const AramContent = () => {
    const currentLang = useSelector((state) => state.translation.lang)
    return (
        <CenterContentBox>
            <AramSearch key={currentLang}/>
            <AramRank/>
        </CenterContentBox>
    );
};

export default AramContent;
